import { Chat, Payment, Payments } from "@mui/icons-material";
import { useTranslations } from "next-intl";
import { IMAGES } from "./Images";

export const CURRENCY_ICON = "₹";
export const PRODUCTS = {
  PL: "PL",
  UCL: "UCL",
  TWL: "TWL",
  RL: "RL",
};

export const PRODUCT_TYPES = {
  PERSONAL_LOAN: "personal-loan",
  USED_CAR_LOAN: "used-car-loan",
  TWO_WHEELER_LOAN: "two-wheeler-loan",
  REPEAT_LOAN: "repeat-loan",
};

export const EMAIL_TYPE = {
  PERSONAL: "PERSONAL",
  WORK: "WORK",
};

export const SUB_PRODUCTS = {
  RL: "RL",
  PL: "PL",
};
export const PRODUCT_HANDLER = {
  "personal-loan": "PL",
  "repeat-loan": "RL",
  "two-wheeler-loan": "TWL",
  "used-car-loan": "UCL",
  "credit-score": "CS",
};

export const getKeyByValue = (object, value) => {
  return Object.entries(object).find(([key, val]) => val === value)?.[0];
};
export const PRODUCTS_LIST = {
  PL: "Personal Loan",
  UCL: "Used Car Loan",
  TWL: "Two Wheeler Loan",
  UBL: "Unsecured Business Loan",
};

export const LOGIN_STATS = () => {
  const t = useTranslations("Login");
  return [
    {
      icon: <Chat sx={{ color: "white" }} />,
      text: t("customers"),
      value: `9 ${t("lacs")}+`,
    },
    {
      icon: <Payments sx={{ color: "white" }} />,
      text: t("disbursed"),
      value: `100 ${t("crore")}+`,
    },
    {
      icon: <Payment sx={{ color: "white" }} />,
      text: t("loans"),
      value: `6 ${t("million")}`,
    },
  ];
};
export const PERSONAL_LOAN_STEPS = [
  "Personal Details",
  "Loan Offer",
  "KYC Verification",
  "Work Details",
  "Re-Payment Setup",
  "E-Sign",
];
export const LOAN_SANCTION_STEPS = () => {
  const t = useTranslations("ApplyLoan.steps");
  return [
    {
      text: t("step1"),
      subText: t("step1desc"),
      icon: IMAGES.person,
      isDivider: true,
    },
    {
      text: t("step2"),
      subText: t("step2desc"),
      icon: IMAGES.bank,
      isDivider: true,
    },
    {
      text: t("step3"),
      subText: t("step3desc"),
      icon: IMAGES.fingerprint,
      isDivider: false,
    },
  ];
};
export const CERSAI_CONSENT = () => {
  const t = useTranslations("IdentityDetails");
  return [
    {
      value: "Y",
      name: <span>{t("cersai")}</span>,
    },
  ];
};
export const CONSENT_PERMISSION_STEPS = () => {
  const t = useTranslations("IdentityDetails.consent");
  return [
    {
      text: t("location"),
      subText: t("locationdesc"),
      icon: IMAGES.consentLocation,
      isDivider: true,
    },
    {
      text: t("webcam"),
      subText: t("webcamdesc"),
      icon: IMAGES.consentStorage,
      isDivider: true,
    },
    {
      text: t("notifications"),
      subText: t("notificationdesc"),
      icon: IMAGES.notification,
      isDivider: true,
    },
  ];
};
export const BANK_VERIFICATION_STEPS = [
  {
    text: "Select Bank",
    icon: IMAGES.whiteBank,
  },
  {
    text: "Verify Bank Statement via Net Banking",
    icon: IMAGES.whiteFinger,
  },
];
export const FACE_VERIFICATION_STEPS = [
  {
    text: "Find a place with proper lighting.",
    icon: IMAGES.lighting,
    borderRequired: true,
  },
  {
    text: "Ensure you are not wearing any glasses or hat/cap.",
    icon: IMAGES.hatGlass,
    borderRequired: true,
  },
  {
    text: "Hold your phone exactly in front of your face.",
    icon: IMAGES.webCam,
    borderRequired: true,
  },
  {
    text: "Ensure, the Selfie should not be a photo of an existing photo.",
    icon: IMAGES.picture,
    borderRequired: false,
  },
];

export const STAGE = {
  APPLY_LOAN: "APPLY_LOAN",
  LOAN_AMOUNT: "LOAN_AMOUNT",
  PAN: "PAN",
  CKYC: "CKYC",
  ADD_ADDRESS: "ADD_ADDRESS",
  PERSONAL_DETAILS: "PERSONAL_DETAILS",
  OFFERS: "OFFERS",
  EKYC: "EKYC",
  DIGI_KYC: "DIGI_KYC",
  WORK_DETAILS: "WORK_DETAILS",
  MANDATE: "MANDATE",
  E_SIGN: "E_SIGN",
  E_SIGN_KFS_INCOMPLETE: "E_SIGN_KFS_INCOMPLETE",
  CLOSED: "CLOSED",
  CREDIT_QUEUE: "CREDIT_QUEUE",
  BRE_CPV_TVR: "BRE_CPV_TVR",
  MANDATE_PENNYDROP: "MANDATE_PENNYDROP",
  REVERSE_PENNY_DROP: "REVERSE_PENNY_DROP",
  RPD_MODE: "RPD_MODE",
  LMS_ONBOARDING: "LMS_ONBOARDING",
  DISBURSED: "DISBURSED",
  REPAYMENT: "REPAYMENT",
  COMPLETED: "COMPLETED",
  VKYC: "VKYC",
  VKYC_SCHEDULED: "VKYC_SCHEDULED",
  PAN_AADHAAR_LINK_PENDING: "PAN_AADHAAR_LINK_PENDING",
  RPD_SUCCESS: "RPD_SUCCESS",
};

export const SUBSTAGE = {
  PAN_CKYC_FAIL: "PAN_CKYC_FAIL",
  CLOSED: "CLOSED",
  DIGI_KYC_FAIL: "DIGI_KYC_FAIL",
  PAN_AADHAR_MISMATCH: "PAN_AADHAR_MISMATCH",
  CREDIT_DECISION_NAME_MISMATCH: "CREDIT_DECISION_NAME_MISMATCH",
  PAN_DOB_MISMATCH: "PAN_DOB_MISMATCH",
  PAN_DOB_MATCH_DEFERRED: "PAN_DOB_MATCH_DEFERRED",
  PAN_CKYC_NAME_MATCH_CREDIT_QUEUE: "PAN_CKYC_NAME_MATCH_CREDIT_QUEUE",
  PAN_CKYC_NAME_MATCH_REJECTED: "PAN_CKYC_NAME_MATCH_REJECTED",
  REJECT: "REJECT",
  CREDIT_QUEUE: "CREDIT_QUEUE",
  UCIC_FAILED: "UCIC_FAILED",
  UCIC_INITIATED: "UCIC_INITIATED",
  HUNTER_FAILED: "HUNTER_FAILED",
  BUREAU_FAILED: "BUREAU_FAILED",
  UCIC_REQUEST_ACCEPT: "UCIC_REQUEST_ACCEPT",
  BUREAU_REQUEST_ACCEPT: "BUREAU_REQUEST_ACCEPT",
  POLICY_SKIPPED: "POLICY_SKIPPED",
  LAT_LONG_ACCEPT: "LAT_LONG_ACCEPT",
  BRE1: "BRE1",
  BRE2_AA_ACCEPT: "BRE2_AA_ACCEPT",
  BRE2_AA: "BRE2_AA",
  BRE2_PERFIOS_ACCEPT: "BRE2_PERFIOS_ACCEPT",
  DIGI_KYC_FAIL_FACEMATCH: "DIGI_KYC_FAIL_FACEMATCH",
  KYC_BANK_NAME_MATCH_CREDIT_QUEUE: "KYC_BANK_NAME_MATCH_CREDIT_QUEUE",
  PAN_KYC_NAME_MATCH_CREDIT_QUEUE: "PAN_KYC_NAME_MATCH_CREDIT_QUEUE",
  PAN_BANK_NAME_MATCH_CREDIT_QUEUE: "PAN_BANK_NAME_MATCH_CREDIT_QUEUE",
  AA_PIRMID_DATA_NOT_AVAILABLE_LIMIT_EXHAUSTED:
    "AA_PIRMID_DATA_NOT_AVAILABLE_LIMIT_EXHAUSTED",
  AA_PIRMID_DATA_NOT_AVAILABLE: "AA_PIRMID_DATA_NOT_AVAILABLE",
  UCIC_HUNTER_DECISION_POSTPONED_REJECT:
    "UCIC_HUNTER_DECISION_POSTPONED_REJECT",
  PAN_DOB_NOT_VERIFIED: "PAN_DOB_NOT_VERIFIED",
  DIGI_KYC_INITIATED: "DIGI_KYC_INITIATED",
  AA_REQUEST_FAILED: "AA_REQUEST_FAILED",
  AA_WEB_REQUEST_URL_FAILED: "AA_WEB_REQUEST_URL_FAILED",
  AA_WEB_REQUEST_URL_ACCEPT: "AA_WEB_REQUEST_URL_ACCEPT",
  AA_FAILED_PERFIOS_INITIALTED: "AA_FAILED_PERFIOS_INITIALTED",
  PERFIOS_REQUEST_FAILED: "PERFIOS_REQUEST_FAILED",
  E_MANDATE_ATTEMPT_EXHAUSTED: "E_MANDATE_ATTEMPT_EXHAUSTED",
  MANDATE_LIMIT_EXHAUSTED: "MANDATE_LIMIT_EXHAUSTED",
  UPI_MANDATE_LIMIT_EXHAUSTED: "UPI_MANDATE_LIMIT_EXHAUSTED",
  UPI_MANDATE_CALLBACK_RECIEVED_REJECTED:
    "UPI_MANDATE_CALLBACK_RECIEVED_REJECTED",
  REPAYMENT_SCHEDULE_BUILD_FAILED: "REPAYMENT_SCHEDULE_BUILD_FAILED",
  E_MANDATE_CREATED_SUCCESS: "E_MANDATE_CREATED_SUCCESS",
  UCIC1_AWAITING_CALLBACK: "UCIC1_AWAITING_CALLBACK",
  ADDRESS_CONFIRMED: "ADDRESS_CONFIRMED",
  UCIC_REQUEST_FAILED: "UCIC_REQUEST_FAILED",
  PAN_BANK_NAME_MATCH: "PAN_BANK_NAME_MATCH",
  UCIC2_AWAITING_CALLBACK: "UCIC2_AWAITING_CALLBACK",
  HUNTER_ACCEPTED: "HUNTER_ACCEPTED",
  PAN_AADHAR_MATCH_DEFERRED: "PAN_AADHAR_MATCH_DEFERRED",
  PAN_AADHAR_MATCH_DEFERRED:  "PAN_AADHAR_MATCH_DEFERRED",
  EKYC_MAX_ATTEMPTS_REACHED: "EKYC_MAX_ATTEMPTS_REACHED",
  EKYC_PENDING: "EKYC_PENDING",
  EKYC_INITIATED: "EKYC_INITIATED",
  KYC_BANK_NAME_MATCH_CREDIT_QUEUE_APPROVED:
    "KYC_BANK_NAME_MATCH_CREDIT_QUEUE_APPROVED",
  AA_PIRMID_FAILED: "AA_PIRMID_FAILED",
  EKYC_MAX_ATTEMPTS_REACHED: "EKYC_MAX_ATTEMPTS_REACHED",
  EKYC_PENDING: "EKYC_PENDING",
  EKYC_INITIATED: "EKYC_INITIATED",
  BANK_PENNYDROP: "BANK_PENNYDROP",
  MANADATE_FAILED: "MANADATE_FAILED",
  AA_CALLBACK_TIMEOUT: "AA_CALLBACK_TIMEOUT",
  E_MANDATE_ATTEMPT_EXHAUSTED: "E_MANDATE_ATTEMPT_EXHAUSTED",
  PENNYDROP_RETRY: "PENNYDROP_RETRY",
  MANDATE_POLLING: "MANDATE_POLLING",
  EKYC_NAME_MATCH_FAILED: "EKYC_NAME_MATCH_FAILED",
  EKYC_COMPLETED: "EKYC_COMPLETED",
  EKYC_FAILED: "EKYC_FAILED",
  E_MANDATE_CREATED_FAILED: "E_MANDATE_CREATED_FAILED",
};

export const KYCSTATUS = {
  STP: "STP",
  CREDIT_QUEUE: "CREDIT_QUEUE",
  PAN_KYC_NAME_MATCH_CREDIT_QUEUE: "PAN_KYC_NAME_MATCH_CREDIT_QUEUE",
};

export const BANKDETAILS_SETUP_NOTIFICATION = () => {
  const t = useTranslations("aabankdetails");
  return [
    {
      sNo: "1.",
      text: t("step1"),
    },
    {
      sNo: "2.",
      text: t("step2"),
    },
  ];
};

export const MANDATE_BANK_SETUP_NOTIFICATION = () => {
  const t = useTranslations("RepaymentBanking");
  return [
    {
      sNo: "1.",
      text: t("step1"),
    },
    {
      sNo: "2.",
      text: t("step2"),
    },
  ];
};
export const AA_MANDATE_BANK_SETUP_NOTIFICATION = () => {
  const t = useTranslations("RepaymentBankingAA");
  return [
    {
      sNo: "1.",
      text: t("step1"),
    },
    {
      sNo: "2.",
      text: t("step2"),
    },
  ];
};

export const REPAYMENT_SETUP_NOTIFICATION = () => {
  const t = useTranslations("repaymentSetUp");
  return [
    {
      sNo: "1.",
      text: t("step1"),
    },
    {
      sNo: "2.",
      text: t("step2"),
    },
    {
      sNo: "3.",
      text: t("step3"),
    },
  ];
};

export const MANDATE_SETUP_NOTIFICATION = () => {
  const t = useTranslations("repaymentSetUp.upimodal.steplist");
  return [
    {
      sNo: "1.",
      text: t("step1"),
      desc: t("step1desc"),
      image: IMAGES.openapp,
      isDivider: true,
    },
    {
      sNo: "2.",
      text: t("step2"),
      desc: t("step2desc"),
      image: IMAGES.mandate,
      isDivider: true,
    },
    {
      sNo: "3.",
      text: t("step3"),
      desc: t("step3desc"),
      image: IMAGES.hero,
      isDivider: false,
    },
  ];
};

export const VIDEO_KYC_INSTRUCTIONS = () => {
  const t = useTranslations("videoKyc.videoKycInstruction");
  return [
    {
      title: t("title1"),
      text: t("text1"),
      icon: IMAGES.chargePhone,
    },
    {
      title: t("title2"),
      text: t("text2"),
      icon: IMAGES.goodLighting,
    },
    {
      title: t("title3"),
      text: t("text3"),
      icon: IMAGES.document,
    },
    {
      title: t("title4"),
      text: t("text4"),
      icon: IMAGES.noHatGlass,
    },
    {
      title: t("title5"),
      text: t("text5"),
      icon: IMAGES.wifi,
    },
  ];
};

export const SUB_STAGE_FAILS = [
  SUBSTAGE?.PAN_CKYC_FAIL,
  SUBSTAGE?.DIGI_KYC_FAIL,
  SUBSTAGE?.PAN_AADHAR_MISMATCH,
  SUBSTAGE?.CREDIT_DECISION_NAME_MISMATCH,
  SUBSTAGE?.PAN_DOB_MISMATCH,
  // SUBSTAGE?.PAN_DOB_MATCH_DEFERRED,
  SUBSTAGE?.PAN_CKYC_NAME_MATCH_CREDIT_QUEUE,
  SUBSTAGE?.PAN_CKYC_NAME_MATCH_REJECTED,
];

export const DECISION = {
  REJECT: "reject",
  ACCEPT: "accept",
  RL_ACCEPT: "rl_accept",
};

export const STAGE_PARENT = {
  APPLY_LOAN: "APPLY_LOAN",
  LOAN_AMOUNT: "LOAN_AMOUNT",
  PAN: "PERSONAL_DETAILS", //PERSONAL
  CKYC: "PERSONAL_DETAILS", //PERSONAL
  ADD_ADDRESS: "PERSONAL_DETAILS", //PERSONAL
  PERSONAL_DETAILS: "PERSONAL_DETAILS", //PERSONAL
  OFFERS: "OFFERS", //OFFERS
  DIGI_KYC: "KYC_VERIFICATION", //KYC VERIFICATION
  WORK_DETAILS: "WORK_DETAILS", //WORK_DETAILS
  MANDATE: "MANDATE", //MANDATE
  E_SIGN: "E_SIGN", //E-sign
  E_SIGN_KFS_INCOMPLETE: "E_SIGN", //E-sign
  CLOSED: "CLOSED",
  CREDIT_QUEUE: "CREDIT_QUEUE",
  BRE_CPV_TVR: "BRE_CPV_TVR",
  LMS_ONBOARDING: "LMS_ONBOARDING",
};

export const WEB_EVENTS = {
  PIN_UNSERVICEABLE: "UNSERVICEABLE_REJECT_2.O",
  ON_LOGIN_SCREEN: "0_ON_LOGIN_SCREEN",
  REGISTRATION_COMPLETED: "1_REGISTRATION_COMPLETED",
  SIGNIN_COMPLETED: "2_SIGNIN_COMPLETED",
  APPLY_LOAN_STARTED: "3_APPLY_LOAN_STARTED",
  PAN_DETAILS_STARTED: "4_PAN_DETAILS_STARTED",
  CKYC_STARTED: "5_CKYC_STARTED",
  PERSONAL_DETAILS_STARTED: "6_PERSONAL_DETAILS_STARTED",
  MAILING_ADDRESS_STARTED: "6_1_MAILING_ADDRESS_STARTED",
  ON_OFFER_SCREEN: "10_ON_OFFER_SCREEN",
  SELECTED_LOAN_AMOUNT_AGREE: "10_1_SELECTED_LOAN_AMOUNT_AGREE",
  UNLOCK_OFFER_SELECTED: "10_2_UNLOCK_OFFER_SELECTED",
  ON_BANK_SELECTION_SCREEN: "12_ON_BANK_SELECTION_SCREEN",
  AA_INFO_SCREEN_VIEWED: "12_AA_INFO_SCREEN_VIEWED",
  BANK_VERIFICATION_PERFIOS_STARTED: "13_BANK_VERIFICATION_PERFIOS_STARTED",
  AA_INFO_PROCEED_CLICKED: "14_AA_INFO_PROCEED_CLICKED",
  ONEMONEY_STARTED: "14_ONEMONEY_STARTED",
  AA_REDIRECT_TO_APP: "14_1_AA_REDIRECT_TO_APP",
  ON_KYC_VERIFICATION_SCREEN: "15_ON_KYC_VERIFICATION_SCREEN",
  ON_EKYC_VERIFICATION_SCREEN: "15_ON_EKYC_VERIFICATION_SCREEN",
  ON_WORK_DETAILS_STARTED: "17_ON_WORK_DETAILS_STARTED",
  MODE_OF_REPAYMENT_STARTED: "18_MODE_OF_REPAYMENT_STARTED",
  MODE_OF_REPAYMENT_DEBIT_CARD_STARTED: "18_1_DEBIT_CARD_STARTED",
  MODE_OF_REPAYMENT_NETBANKING_STARTED: "18_2_NETBANKING_STARTED",
  UPI_AUTO_PAY_STARTED: "18_4_UPI_AUTO_PAY_STARTED",
  ON_INSURANCE_SCREEN: "20_ON_INSURANCE_SCREEN",
  E_SIGN_STARTED: "21_E_SIGN_STARTED",
  OFFER_SCREEN_INSURANCE_OPTED: "10_3_OFFER_SCREEN_INSURANCE_OPTED",
  OFFER_SCREEN_INSURANCE_SKIPPED: "10_4_OFFER_SCREEN_INSURANCE_SKIPPED",
  INSURANCE_OPTED_FINAL: "20_1_INSURANCE_OPTED_FINAL",
  INSURANCE_SKIPPED_FINAL: "20_2_INSURANCE_SKIPPED_FINAL",
  PAYTM_REDIRECTION_TRANSACTION_TOKEN: "27_PAYTM_REDIRECTION_TRANSACTION_TOKEN",
  PAY_ADVANCE_EMI: "28_PAY_ADVANCE_EMI",
  CKYC_STARTED: "5_CKYC_STARTED",
  CKYC_OTP_GENERATED: "5_1_CKYC_OTP_GENERATED",
  CKYC_SKIPPED: "5_3_CKYC_SKIPPED",
  CKYC_ALTERNATE_MOBILE_PROVIDED: "5_4_CKYC_ALTERNATE_MOBILE_PROVIDED",
  CKYC_OTP_ENTERED: "5_6_CKYC_OTP_ENTERED",
  CKYC_OTP_REGENERATED: "5_8_CKYC_OTP_REGENERATED",
  CKYC_OTP_EXPIRED: "5_9_CKYC_OTP_EXPIRED",
  CKYC_INVALID_OTP: "5_10_CKYC_INVALID_OTP",
  VKYC_STARTED: "29_VKYC_STARTED",
  RPD_SELECTED: "31_RPD_SELECTED",
  CPV_SELECTED: "32_CPV_SELECTED",
  RPD_INITIATED: "31_1_RPD_INITIATED",
  RL_OFFER_ACCEPTED: "101_RL_OFFER_ACCEPTED",
  RL_ON_KYC_SCREEN: "102_RL_ON_KYC_SCREEN",
  RL_ALTERNATE_ADDRESS_CHANGED: "106_RL_ALTERNATE_ADDRESS_CHANGED",
  RL_ON_BANK_ACCOUNT_CONFIRMATION: "108_RL_ON_BANK_ACCOUNT_CONFIRMATION",
  RL_BANK_ACCOUNT_CHANGED: "108_1_RL_BANK_ACCOUNT_CHANGED",
  RL_ON_MANDATE: "109_RL_ON_MANDATE",
  RL_DEBIT_CARD_STARTED: "109_1_RL_DEBIT_CARD_STARTED",
  RL_NETBANKING_STARTED: "109_2_RL_NETBANKING_STARTED",
  RL_UPI_AUTO_PAY_STARTED: "110_3_RL_UPI_AUTO_PAY_STARTED",
  RL_ON_INSURANCE_SCREEN: "111_RL_ON_INSURANCE_SCREEN",
  RL_E_SIGN_STARTED: "112_RL_E_SIGN_STARTED",
};

export const FIREBASE_EVENTS = {
  [WEB_EVENTS.PIN_UNSERVICEABLE]: "UNSERVICEABLE_REJECT_2_0",
  [WEB_EVENTS.ON_LOGIN_SCREEN]: "ON_LOGIN_SCREEN_0",
  [WEB_EVENTS.SIGNIN_COMPLETED]: "SIGNIN_COMPLETED_2",
  [WEB_EVENTS.APPLY_LOAN_STARTED]: "APPLY_LOAN_STARTED_3",
  [WEB_EVENTS.PAN_DETAILS_STARTED]: "PAN_DETAILS_STARTED_4",
  [WEB_EVENTS.CKYC_STARTED]: "CKYC_STARTED_5",
  [WEB_EVENTS.PERSONAL_DETAILS_STARTED]: "PERSONAL_DETAILS_STARTED_6",
  [WEB_EVENTS.MAILING_ADDRESS_STARTED]: "MAILING_ADDRESS_STARTED_6_1",
  [WEB_EVENTS.ON_OFFER_SCREEN]: "ON_OFFER_SCREEN_10",
  [WEB_EVENTS.SELECTED_LOAN_AMOUNT_AGREE]: "SELECTED_LOAN_AMOUNT_AGREE_10_1",
  [WEB_EVENTS.UNLOCK_OFFER_SELECTED]: "UNLOCK_OFFER_SELECTED_10_2",
  [WEB_EVENTS.ON_BANK_SELECTION_SCREEN]: "ON_BANK_SELECTION_SCREEN_12",
  [WEB_EVENTS.BANK_VERIFICATION_PERFIOS_STARTED]:
    "BANK_VERIFICATION_PERFIOS_STARTED_13",
  [WEB_EVENTS.ONEMONEY_STARTED]: "ONEMONEY_STARTED_14",
  [WEB_EVENTS.AA_REDIRECT_TO_APP]: "AA_REDIRECT_TO_APP_14_1",
  [WEB_EVENTS.ON_KYC_VERIFICATION_SCREEN]: "ON_KYC_VERIFICATION_SCREEN_15",
  [WEB_EVENTS.ON_EKYC_VERIFICATION_SCREEN]: "ON_EKYC_VERIFICATION_SCREEN_15",
  [WEB_EVENTS.ON_WORK_DETAILS_STARTED]: "ON_WORK_DETAILS_STARTED_17",
  [WEB_EVENTS.MODE_OF_REPAYMENT_STARTED]: "MODE_OF_REPAYMENT_STARTED_18",
  [WEB_EVENTS.MODE_OF_REPAYMENT_DEBIT_CARD_STARTED]: "DEBIT_CARD_STARTED_18_1",
  [WEB_EVENTS.MODE_OF_REPAYMENT_NETBANKING_STARTED]: "NETBANKING_STARTED_18_2",
  [WEB_EVENTS.UPI_AUTO_PAY_STARTED]: "UPI_AUTO_PAY_STARTED_18_4",
  [WEB_EVENTS.ON_INSURANCE_SCREEN]: "ON_INSURANCE_SCREEN_20",
  [WEB_EVENTS.E_SIGN_STARTED]: "E_SIGN_STARTED_21",
  [WEB_EVENTS.PAYTM_REDIRECTION_TRANSACTION_TOKEN]:
    "PAYTM_REDIRECTION_TRANSACTION_TOKEN_27",
  [WEB_EVENTS.PAY_ADVANCE_EMI]: "PAY_ADVANCE_EMI_28",
  [WEB_EVENTS.CKYC_STARTED]: "CKYC_STARTED_5",
  [WEB_EVENTS.CKYC_OTP_GENERATED]: "CKYC_OTP_GENERATED_5_1",
  [WEB_EVENTS.CKYC_SKIPPED]: "CKYC_SKIPPED_5_3",
  [WEB_EVENTS.CKYC_ALTERNATE_MOBILE_PROVIDED]: "CKYC_ALTERNATE_MOBILE_5_4",
  [WEB_EVENTS.CKYC_OTP_ENTERED]: "CKYC_OTP_ENTERED_5_6",
  [WEB_EVENTS.CKYC_OTP_REGENERATED]: "CKYC_OTP_REGENERATED_5_8",
  [WEB_EVENTS.CKYC_OTP_EXPIRED]: "CKYC_OTP_EXPIRED_5_9",
  [WEB_EVENTS.CKYC_INVALID_OTP]: "CKYC_INVALID_OTP_5_10",
  [WEB_EVENTS.VKYC_STARTED]: "VKYC_STARTED_29",
  [WEB_EVENTS.RPD_SELECTED]: "RPD_SELECTED_31",
  [WEB_EVENTS.CPV_SELECTED]: "CPV_SELECTED_32",
  [WEB_EVENTS.RPD_INITIATED]: "RPD_INITIATED_31_1",
  [WEB_EVENTS.RL_OFFER_ACCEPTED]: "RL_OFFER_ACCEPTED_101",
  [WEB_EVENTS.RL_ON_KYC_SCREEN]: "RL_ON_KYC_SCREEN_102",
  [WEB_EVENTS.RL_ALTERNATE_ADDRESS_CHANGED]: "RL_ALTERNATE_ADDRESS_CHANGED_106",
  [WEB_EVENTS.RL_ON_BANK_ACCOUNT_CONFIRMATION]:
    "RL_ON_BANK_ACCOUNT_CONFIRMATION_108",
  [WEB_EVENTS.RL_BANK_ACCOUNT_CHANGED]: "RL_BANK_ACCOUNT_CHANGED_108_1",
  [WEB_EVENTS.RL_ON_MANDATE]: "RL_ON_MANDATE_109",
  [WEB_EVENTS.RL_DEBIT_CARD_STARTED]: "RL_DEBIT_CARD_STARTED_109_1",
  [WEB_EVENTS.RL_NETBANKING_STARTED]: "RL_NETBANKING_STARTED_109_2",
  [WEB_EVENTS.RL_UPI_AUTO_PAY_STARTED]: "RL_UPI_AUTO_PAY_STARTED_110_3",
  [WEB_EVENTS.RL_ON_INSURANCE_SCREEN]: "RL_ON_INSURANCE_SCREEN_111",
  [WEB_EVENTS.RL_E_SIGN_STARTED]: "RL_E_SIGN_STARTED_112",
};

export const MOENGAGE_EVENTS = {
  HOME_CARD_CLICKED: "HOME_CARD_CLICKED",
  PHONE_OTP_GENERATED: "0_1_PHONE_OTP_GENERATED",
  VERIFY_OTP_MODAL_OPENED: "0_2_VERIFY_OTP_MODAL_OPENED",
  VERIFY_OTP_MODAL_CLOSED: "0_3_VERIFY_OTP_MODAL_CLOSED",
  INVALID_OTP: "0_4_INVALID_OTP",
  LOCATION_PERMISSION_DENIED: "3_1_LOCATION_PERMISSION_DENIED",
  LOCATION_PERMISSION_GRANTED: "3_2_LOCATION_PERMISSION_GRANTED",
  CAMERA_PERMISSION_DENIED: "3_3_CAMERA_PERMISSION_DENIED",
  CAMERA_PERMISSION_GRANTED: "3_4_CAMERA_PERMISSION_GRANTED",
  INSTRUCTIONS_VIEWED: "3_5_INSTRUCTIONS_VIEWED",
  PAN_REGEX_INVALID: "4_1_PAN_REGEX_INVALID",
  PAN_INVALID: "4_2_PAN_INVALID",
  PERSONAL_EMAIL_OTP_GENERATED: "17_1_PERSONAL_EMAIL_OTP_GENERATED",
  VERIFY_PERSONAL_EMAIL_OTP_MODAL_OPENED:
    "17_2_VERIFY_PERSONAL_EMAIL_OTP_MODAL_OPENED",
  VERIFY_PERSONAL_EMAIL_OTP_MODAL_CLOSED:
    "17_3_VERIFY_PERSONAL_EMAIL_OTP_MODAL_CLOSED",
  INVALID_PERSONAL_EMAIL_OTP: "17_4_INVALID_PERSONAL_EMAIL_OTP",
};

export const ERROR_CODE = {
  ERR_100: "EMAN100",
  ERR_101: "EMAN101",
  ERR_102: "EMAN102",
  ERR_103: "EMAN103",
  ERR_104: "EMAN104",
  ERR_105: "EMAN105",
  ERR_106: "EMAN106",
};

export const PAN_TYPES = [
  { name: "Individual", value: "individual" },
  { name: "Proprietorship", value: "proprietorship" },
];

export const LOADER_QUOTES = [
  { label: "Processing Your application...." },
  { label: "Please wait..." },
];
export const OFFER_QUOTES = [
  {
    label: "💯 100% Digital Process",
    subLabel: "No paperwork, no stress — just a few simple taps.",
  },
  {
    label: "⚡ Instant Personal Loans",
    subLabel: "Apply, verify, and get funds — all within minutes.",
  },
  {
    label: "🛡️ Fast Loans with the Trust of Hero",
    subLabel: "Apply, verify, and get funds — all within minutes.",
  },
  {
    label: "🔐 Verification & Security",
    subLabel:
      "Your details are in safe hands — we’re ensuring everything checks out.",
  },
  {
    label: "🔓 Unlock Your Personal Loan Instantly",
    subLabel: "Quick approvals with minimal steps for maximum convenience.",
  },
  {
    label: "📆 Flexible EMIs",
    subLabel: "Tailored EMI plans designed to fit your budget and lifestyle.",
  },
  {
    label: "🌟 Trusted by Millions",
    subLabel: "Right place, right time — join the community that trusts us.",
  },
  {
    label: "⏳ We’re Almost There",
    subLabel: "Running final checks — just a few seconds more!",
  },
];

export const AMPLITUDE_CODES = {
  IDENTIFIERS: {
    APP_ID: "appId",
    CUSTOMER_ID: "customerId",
  },
};
export const MOENGAGE_CODES = {
  USER_ATTRIBUTES: {
    APP_ID: "appId",
    MOBILE_NUMBER: "mobileNumber",
    RL_APP_ID: "rl_App_Id",
    RL_OFFER_EXPIRY: "rl_Offer_Expiry",
    RL_Offer_Amount: "rl_Offer_Amount",
  },
};

export const ERROR_IMAGES = {
  SUCCESS: IMAGES.aadharcode,
  APPROVED: IMAGES.aadharcode,
  COMPLETED: IMAGES.aadharcode,
  FAILED: IMAGES.aadharcode,
  REJECTED: IMAGES.aadharcode,
  ERROR: IMAGES.aadharcode,
  NAME_MISMATCH: IMAGES.aadharcode,
  FACE_MISMATCH: IMAGES.aadharcode,
  UNDER_REVIEW: IMAGES.aadharcode,
  KYC_FAILED: IMAGES.aadharcode,
  PROCESSING: IMAGES.aadharcode,
  ALERT: IMAGES.aadharcode,
  MANDATE_LIMIT_EXHAUSTED: IMAGES.attemptError,
  TECHNICAL_ERROR: IMAGES.aadharcode,
  TIMEOUT: IMAGES.attemptError,
  INFO: IMAGES.aadharcode,
};
export const CREDIT_SCORE_FEATURES = [
  { icon: IMAGES.preApprovedIcon, textKey: "preapprovedloan" },
  { icon: IMAGES.personalizedIcon, textKey: "personlizedscore" },
  { icon: IMAGES.abolutalyFreeIcon, textKey: "absolutelyfree" },
  { icon: IMAGES.secureIcon, textKey: "secireresult" },
];

export const APP_KEYS = Object.freeze({
  PRODUCT_TYPE: "productType",
  MANDATE_ID: "mandateId",
  CURRENT_ACCOUNT_WARNING_SHOWN: "currentAccountWarningShown",
  EVENTS_ONCE: "events_once",
  HFC_EVENTS: "hfc_events",
});

export const RESTRICTED_EMAIL_DOMAINS = [
  "Gmail.com",
  "Yahoo.com",
  "Yahoo.co.in",
  "Ymail.com",
  "Hotmail.com",
  "Outlook.com",
  "Live.com",
  "Rediffmail.com",
  "Rediff.com",
  "Tempmail.com",
  "Yopmail.com",
  "Disposablemail.com",
  "Temporarymail.com",
  "Aol.com",
  "Proton.me",
];

export const WAIVER_TYPES = {
  OFFICE_RESIDENCE: "office residence",
  OFFICE: "office",
  WAIVER: "waiver",
  RESIDENCE: "residence",
};

export const PAYMENT_METHODS_MAPPING = {
  upi: "UPI",
  netbanking: "NB",
  debitCard: "CARD",
};

export const JUSPAY_ORDER_STATUS = {
  NEW: "NEW",
  STARTED: "STARTED",
  PENDING_VBV: "PENDING_VBV",
  AUTHORIZING: "AUTHORIZING",
  AUTHORIZED: "AUTHORIZED",
  CHARGED: "CHARGED",
  AUTHENTICATION_FAILED: "AUTHENTICATION_FAILED",
  AUTHORIZATION_FAILED: "AUTHORIZATION_FAILED",
  JUSPAY_DECLINED: "JUSPAY_DECLINED",
  NOT_FOUND: "NOT_FOUND",
  FAILURE: "FAILURE",
};

// non-terminal: keep polling order-status until it settles.
// CHARGED is the only success; anything else terminal is treated as a failure.
export const JUSPAY_PENDING_STATUSES = [
  JUSPAY_ORDER_STATUS.NEW,
  JUSPAY_ORDER_STATUS.STARTED,
  JUSPAY_ORDER_STATUS.PENDING_VBV,
  JUSPAY_ORDER_STATUS.AUTHORIZING,
  JUSPAY_ORDER_STATUS.AUTHORIZED,
];
